import { useMutation } from '@tanstack/react-query';
import { axiosInstance } from '../service/ApiService';

type UploadTextInput = {
  text: string;
  fileType: string;
  fileName?: string;
  spaceId?: string;
  flowId?: string;
  useDocraptor?: boolean;
};

const useUploadTextMutation = () =>
  useMutation({
    mutationFn: async ({ useDocraptor, ...body }: UploadTextInput) => {
      const endpoint =
        body.fileType === 'pdf' && useDocraptor
          ? '/upload/text-docraptor'
          : '/upload/text';
      const { data } = await axiosInstance.post(endpoint, body);
      return data;
    },
  });

type PresignedUrlInput = { url: string };

const useGetPresignedUrlMutation = () =>
  useMutation({
    mutationFn: async ({ url }: PresignedUrlInput) => {
      const { data } = await axiosInstance.get('/upload/presigned-url', {
        params: { url },
      });
      return data;
    },
  });

export type { UploadTextInput, PresignedUrlInput };
export { useUploadTextMutation, useGetPresignedUrlMutation };
